import { FederatedPointerEvent, IDestroyOptions, Text, Texture, utils } from "pixi.js";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { INewsItemOptions } from "./NewsItem";
import { NewsItemWithAvatar } from "./NewsItemWithAvatar";
import { TextWithUnderline } from "by/gamefactory/cityversetycoon/scenes/game/components/TextWithUnderline";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { Event } from "event-system";
import { WalletTabType } from "../../../myWallet/components/WalletTabType";
import { Chain } from "thirdweb";
import { Web3Config } from "../../../../../../web3/config/Web3Config";

export class NewsItemBuildingSold extends NewsItemWithAvatar {
    private static readonly A_PLAYER_TEXT = "A PLAYER HAS JUST PURCHASED\nYOUR BUILDING LOCATED AT";
    private static readonly ADDRESS_TEXT = "ADDRESS";
    private static readonly FOR_TEXT = "FOR";
    private static readonly SEE_TRANSACTION_TEXT = "SEE TRANSACTION DETAILS HERE";

    public readonly onShowMyWallet: Event<WalletTabType>;
    public readonly onSeeTransactionDetails: Event<Chain>;
    
    private readonly web3Config: Web3Config;

    private aPlayerText: Text;
    private addressText: Text;
    private forText: Text;
    private seeTransactionText: TextWithUnderline;

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        options: NewsItemBuildingSoldOptions,
        web3Config: Web3Config
    ) {
        super(
            id,
            newsResources,
            userProfileResources,
            newsResources.assets_views_latest_news_news_tooltip_red_purple_png,
            newsResources.assets_views_latest_news_news_sold_png,
            options.playerAvatarTexture
        );
        this.onSeeTransactionDetails = new Event();
        this.onShowMyWallet = new Event();
        this.web3Config = web3Config;
        this.build(options);
        this.layout();
        this.seeTransactionText.on(utils.isMobile.apple.device ? "pointerup" : "pointerdown", this.onSeeTransactionClickHandle, this);
    }

    private build(options: NewsItemBuildingSoldOptions): void {
        this.aPlayerText = new Text(NewsItemBuildingSold.A_PLAYER_TEXT, new BuildingSoldTextStyle());
        this.addressText = new Text(`${NewsItemBuildingSold.ADDRESS_TEXT} ${options.address}`, new BuildingSoldTextStyle());
        this.forText = new Text(`${NewsItemBuildingSold.FOR_TEXT} $${options.usdNumber}!`, new BuildingSoldTextStyle());
        this.seeTransactionText = new TextWithUnderline(NewsItemBuildingSold.SEE_TRANSACTION_TEXT, new BuildingSoldTextStyle(), 0, -10);
        this.seeTransactionText.eventMode = 'static';
        this.avatar.updateTexture(options.playerAvatarTexture);
        this.icon.eventMode = "static";
        this.icon.on("pointerup", this.onSoldClickHandle, this);

        this.addChild(
            this.aPlayerText,
            this.addressText,
            this.forText,
            this.seeTransactionText,
        );
    }

    private layout(): void {
        this.aPlayerText.position.set(411, 22);
        this.addressText.position.set(411, 95);
        this.forText.position.set(411, 131);
        this.seeTransactionText.position.set(411, 168);
    }

    private async onSoldClickHandle(_event: FederatedPointerEvent): Promise<void> {
        this.onShowMyWallet.emit(WalletTabType.TOKENS);
    }

    private async onSeeTransactionClickHandle(event: FederatedPointerEvent): Promise<void> {
        event.stopPropagation();
        this.onSeeTransactionDetails.emit(this.web3Config.targetChain);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.seeTransactionText.off(utils.isMobile.apple.device ? "pointerup" : "pointerdown", this.onSeeTransactionClickHandle, this);
        this.icon.off("pointerup", this.onSoldClickHandle, this);
        super.destroy(options);
    }
}

export class NewsItemBuildingSoldOptions implements INewsItemOptions {
    public readonly playerAvatarTexture: Texture;
    public readonly address: string;
    public readonly usdNumber: number;

    public constructor(playerAvatarTexture: Texture, address: string, usdNumber: number) {
        this.playerAvatarTexture = playerAvatarTexture;
        this.address = address;
        this.usdNumber = usdNumber;
    }
}

class BuildingSoldTextStyle extends NewsTextStyle {
    public constructor() {
        super();
        this.fontSize = 30;
        this.lineHeight = 36;
    }
}